import { useState } from "react";
import { PortalMainLayout } from "../../components/layout/portal-main-layout";
import { VenueListing } from "../../components/users/venue-listing";
import { AuthorisedPage } from "../auth/authorised-page";

export const VenueListingPage = () => {
  const [unauthorised] = useState({ show: false });

  return (
    <AuthorisedPage>
      <PortalMainLayout isUnauthorised={unauthorised.show}>
        <VenueListing />
      </PortalMainLayout>
    </AuthorisedPage>
  );
};
